import { fromJS } from 'immutable'
import {
  USER_DEACTIVATE_REQUEST,
  USER_DEACTIVATE_SUCCESS,
  USER_DEACTIVATE_FAILURE,
  USER_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  // isAuthenticated: localStorage.getItem('access_token') !== null,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case USER_DEACTIVATE_SUCCESS:
      return state
        .set('isFetching', false)
        .set('type', 'success')
        .set('status', 'Deleted Successfully')
        .set('message', 'The data had successfully been updated')
        .set('employeeDeactivate', fromJS(action.payload.deletedUser))
    case USER_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('type', 'error')
        .set('status', 'Error')
        .set('employeeDeactivate', fromJS(action.payload.message))
        .set('message', fromJS(action.payload.response.message))
    case USER_DEACTIVATE_RESET:
      return state
        .delete('employeeDeactivate')
        .delete('type')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-deactivate-reducer.js